import { SpnyTourEnum, useSuraasaPlusNewYear } from "../Context"
import ResumeTourBox from "../ResumeTourBox"
import { useTourContext } from "../TourProvider"

const ResumeMasterclassTour = ({
  onClose,
  onContinue,
}: {
  onContinue: () => void
  onClose: () => void
}) => {
  const { step } = useTourContext()
  const { spnyMasterclassTour } = useSuraasaPlusNewYear()

  if (spnyMasterclassTour === SpnyTourEnum.initiated && !step) {
    return (
      <ResumeTourBox
        title="Take a quick tour of the Masterclasses Tab?"
        subTitle="Find out how to get the most out of Masterclasses."
        onContinue={onContinue}
        onClose={onClose}
      />
    )
  }
  return null
}

export default ResumeMasterclassTour
